import { useEffect, useState } from "react";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import { Tooltip, toggleClass, } from '@grapecity/wijmo';
import "./gridEvent.css"

function MomSysDecisionCode ( props ) {

    const [disableEdit, setDisableEdit] = useState(false);
    const [disableDelete, setDisableDelete] = useState(false);
    const [grid, setGrid] = useState();

    useEffect(() => {
        let tooltip = new Tooltip();
        (async () => {
            if (grid) {
                grid.formatItem.addHandler((flex, element) => {
                    if (element.panel === flex.cells) {
                        let item = flex.rows[element.row].dataItem
                        let binding = flex.columns[element.col].binding
                        let data = item.description ? item.description : null;
                        toggleClass(element.cell, 'wj-has-notes', binding === "description" && data !== null );
                        if(binding === "description" && data !== null) {
                            tooltip.setTooltip(element.cell, `<h1>${data}<h1>`);
                        }
                    }
                });
            }
        })();
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [grid]);

    const onInitialized = (grid) => {

        if ( grid ) {

            grid.selectionChanged.addHandler((grid, event) => {

                let item = grid.selectedItems && grid.selectedItems[0];

                if ( item ) {

                    switch ( item.decisionCode ) {

                        case "INS000":
                        case "PRO000":
                        case "INSPECT000":

                            setDisableEdit(true);
                            setDisableDelete(true);
                            break;

                        default:

                            setDisableEdit(false);
                            setDisableDelete(false);
                            break;

                    }

                } else {

                    setDisableEdit ( true );
                    setDisableDelete ( true );

                }

            });

            grid.itemsSourceChanged.addHandler((grid, event) => {

                let item = grid.selectedItems && grid.selectedItems[0];

                if ( item ) {

                    switch ( item.decisionCode ) {

                        case "INS000":
                        case "PRO000":
                        case "INSPECT000":

                            setDisableEdit(true);
                            setDisableDelete(true);
                            break;
                            
                        default:

                            setDisableEdit(false);
                            setDisableDelete(false);
                            break;

                    }

                } else {

                    setDisableEdit ( true );
                    setDisableDelete ( true );
                    
                }
                
            });

        }

        setGrid(grid);
        
    }

    return <BasicCrudScreenType 
                id="MomSysUdtDecisionCode" 
                disableEdit={disableEdit} 
                disableDelete={disableDelete} 
                table="MomSysUdtDecisionCode" 
                view="MomSysVwDecisionCode" 
                onInitialized={onInitialized}/>

}

export default MomSysDecisionCode;
